import { supabase } from '@/integrations/supabase/client';
import type { PersonaProfile } from '@/lib/types/persona';

export async function fetchPersonaProfiles(): Promise<PersonaProfile[]> {
  console.info('[Personas] fetchPersonaProfiles start');
  const supabaseClient = supabase as any;
  const { data, error } = await supabaseClient
    .from('personas')
    .select('*')
    .eq('is_active', true)
    .order('name');

  if (error) {
    console.error('[Personas] Failed to fetch profiles', error);
    throw new Error(`Failed to fetch persona profiles: ${error.message}`);
  }

  if (!data || data.length === 0) {
    throw new Error('No persona profiles found in database. Please seed the personas table.');
  }

  console.info('[Personas] fetchPersonaProfiles success', {
    count: data.length,
    ids: data.map((p) => (p as PersonaProfile).id).filter(Boolean),
  });

  return Array.isArray(data) ? (data as PersonaProfile[]) : [];
}
